module.exports = __webpack_public_path__ + "img/photo_tipbox.9ccbd521.png";